import React, { useRef, useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import MUIDataTable from "mui-datatables";
import { ThemeProvider } from "@mui/styles";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";

import apiService from "../service/apiService";


export const statusList = [
  {
    code: "IC",
    label: "Incomplete",
    colorCode: '#a9383d'
  },
  {
    code: "P",
    label: "Pending",
    colorCode: '#e3414a'
  },
  {
    code: "I",
    label: "Initiated",
    colorCode: '#6572c3'
  },
  {
    code: "PR",
    label: "Processing",
    colorCode: '#d3cd55'
  },
  {
    code: "V",
    label: "Verified",
    colorCode: '#55d35c'
  },
  {
    code: "M",
    label: "Migrated",
    colorCode: 'rgb(169 56 61)'
  },
  {
    code: "A",
    label: "All",
    colorCode: 'rgb(169 56 61)'
  },
  {
    code: "ST",
    label: "Stale",
    colorCode: 'rgb(169 56 61)'
  },
  {
    code: "MG",
    label: "Merged",
    colorCode: 'rgb(169 56 61)'
  },
];

function KycComparisionInfo(props) {
  const [displayModal, setDisplayModal] = useState(true);
  const { t } = useTranslation();
  const [responseData, setResponseData] = useState([]);

  console.log(props, "R DAT A");
  const [districtList, setDistrictList] = useState();
  useEffect(() => {
    apiService.getDistrictList().then((response) => {
      setDistrictList(response.data.data);
    });
  }, [])



  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  useEffect(() => {
    if (props && props.customerId && districtList) {
      apiService.getKycInfoData(props.isClean, props.customerId).then((response) => {
        const list = response.data.map(d => ({
          ...d,
          nid: d.nationalId,
          citizenshipIssueDistrict: getDescription(districtList, d.citizenshipIssueDistrict)
        }));
        if (props.kycComparisionInfoObj) list.push(props.kycComparisionInfoObj)
        setResponseData(list);
      });
    }
  }, [props.isClean, props.customerId, districtList && districtList.length])



  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        display: false,
      },
    },
    {
      name: "tempKycId",
      label: "Temporary KYC Id",
      options: {},
    },
    {
      name: "permKycId",
      label: "Permanent KYC Id",
      options: {},
    },
    {
      name: "customerName",
      label: "Customer Name",
      options: {},
    },
    {
      name: "fatherName",
      label: "Father Name",
      options: {
        display: !props.isCompany
      },
    },
    {
      name: "grandFatherName",
      label: "Grand Father Name",
      options: {
        display: !props.isCompany
      },
    },
    {
      name: "nid",
      label: "National Identification Number",
      options: {
        display: !props.isCompany
      },
    },
    {
      name: "citizenshipNo",
      label: "Citizenship No",
      options: {
        display: !props.isCompany
      },
    },
    {
      name: "citizenshipIssueYear",
      label: "Citizenship Issue Year",
      options: {
        display: !props.isCompany
      },
    },
    {
      name: "citizenshipIssueDistrict",
      label: "Citizenship Issue District",
      options: {
        display: !props.isCompany
      },
    },
    {
      name: "dob",
      label: "Date of Birth",
      options: {
        display: !props.isCompany
      },
    },
    {
      name: "regNo",
      label: "Registration no",
      options: {
        display: props.isCompany == null || props.isCompany
      },
    },
    {
      name: "pan",
      label: "PAN",
      options: {},
    },
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            statusList.find((ss) => ss.code === value) || { label: value }
          ).label;
        },
      },
    },
    {
      name: "phoneNo",
      label: "Phone no",
      options: {},
    },
    {
      name: "email",
      label: "Email",
      options: {},
    },
    {
      name: "birthCertificateNo",
      label: "Birth Certificate No",
      options: {
        display: !props.isCompany
      },
    }
  ];

  const hideModal = () => {
    setDisplayModal(false);
  };

  const toast = useRef();

  const renderFooter = () => {
    return (
      <>
        <Button
          label="Close"
          icon="pi pi-times"
          onClick={() => {
            props.onHide();
          }}
          className="p-button-text"
        />
      </>
    );
  };

  return (
    <div className="dialog">
      <div id="kycComparisionInfo" className="card">
        <Toast ref={toast} />
        <Dialog
          header={t("kycComparisionInfo")}
          visible={props.visible || displayModal}
          style={{ width: "100%", height: "500px" }}
          footer={renderFooter}
          onHide={props.onHide || hideModal}
        >
          <ThemeProvider theme={createTheme()}>
            <MUIDataTable
              data={responseData}
              options={{
                selectToolbarPlacement: "none",
                selectableRowsHideCheckboxes: true,
                filter: false,
                search: false,
                print: false,
                download: false,
                viewColumns: false,
                fixedHeader: true,
                tableBodyMaxHeight: '400px',
                setRowProps: row => {
                  console.log('rowcheck', row);
                  if (!row[0])
                    return {
                      style: { background: "#efffef" }
                    };
                }
              }}
              columns={columns} />
          </ThemeProvider>
        </Dialog>
      </div>
    </div>
  );
}

export default KycComparisionInfo;
